import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import config from '../functions/config';

import {
  faTachometerAlt,
  faUsers,
  faRightFromBracket,
  faBook,
  faListCheck,
  faCartShopping,
  faBagShopping,
} from "@fortawesome/free-solid-svg-icons";

const BooksList = () => {
  const [books, setBooks] = useState([]);
  const [notification, setNotification] = useState(null); // Move notification state here

  // Fetch books from the backend
  useEffect(() => {
    fetchBooks();
  }, []);

  const fetchBooks = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/register-book/`);

      if (response.ok) {
        const data = await response.json();
        setBooks(data.books);
      } else {
        setNotification({ type: 'error', message: 'Failed to fetch books' });
      }
    } catch (error) {
      console.error('Error fetching books:', error);
      setNotification({ type: 'error', message: 'Error fetching books' });
    }
  };

  const handleDelete = async (bookId) => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/register-book/${bookId}/`, {
        method: 'DELETE',
      });
      if (response.ok) {
        setNotification({ type: "success", message: "Book deleted successfully!" });
        fetchBooks(); // Refresh the list
      } else {
        setNotification({ type: 'error', message: 'Failed to delete book' });
      }
    } catch (error) {
      console.error('Error deleting book:', error);
      setNotification({ type: 'error', message: 'Error deleting book' });
    }
  };

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light fixed-top">
        <a className="navbar-brand text-light" href="#">Admin</a>
        <button
          className="navbar-toggler bg-light"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto flex-column vertical-nav px-3">
            <li className="nav-item">
              <a className="nav-link text-light" href="/admin">
                <span className="nav-icon">
                  <FontAwesomeIcon icon={faTachometerAlt} />
                </span>
                <span className="nav-text">Dashboard</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/register-book">
                <span className="nav-icon">
                  <FontAwesomeIcon icon={faBook} />
                </span>
                <span className="nav-text">Register Book</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/list-users">
                <span className="nav-icon">
                  <FontAwesomeIcon icon={faUsers} />
                </span>
                <span className="nav-text">Manage User</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/view-books">
                <span className="nav-icon">
                  <FontAwesomeIcon icon={faListCheck} />
                </span>
                <span className="nav-text text-warning">Manage Book</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/adminpurchase">
                <span className="nav-icon">
                  <FontAwesomeIcon icon={faCartShopping} />
                </span>
                <span className="nav-text">Purchase History</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-light" href="/adminrent">
                <span className="nav-icon">
                  <FontAwesomeIcon icon={faBagShopping} />
                </span>
                <span className="nav-text">Rental History</span>
              </a>
            </li>
          </ul>
          <ul className="navbar-nav ml-auto pr-5">
            <li className="nav-item mr-5">
              <a className="nav-link text-light fixed-right" href="#logout">
                <FontAwesomeIcon icon={faRightFromBracket} /> Logout
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {/* Notification */}
      {notification && (
        <div
          style={{
            position: "fixed",
            top: "30px",
            right: "20px",
            backgroundColor: notification.type === "success" ? "#28a745" : "#dc3545",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            zIndex: 9999,
          }}
        >
          {notification.message}
        </div>
      )}

      {/* Book List */}
      <div className="container content px-5 mt-5 pt-4">
        <h1 className="mb-4">Book List</h1>
        <div className="row">
          {books.map((book) => (
            <div className="col-md-4 mb-4" key={book.id}>
              <div className="card shadow-sm border-light rounded position-relative">
                {/* Book Image */}
                {book.image && (
                  <img
                    src={book.image ? `${config.BASE_URL}${book.image}` : "https://via.placeholder.com/150"} // Handle relative paths with fallback
                    alt={`${book.title} Cover`} // Descriptive alt text for accessibility
                    className="card-img-top img-thumbnail"
                    style={{
                      position: 'absolute',
                      top: '-21px',
                      right: '-21px',
                      width: '150px',
                      height: '150px',
                      objectFit: 'cover',
                      borderRadius: '50%',
                    }}
                    onError={(e) => (e.target.src = "https://via.placeholder.com/150")} // Fallback if the image fails to load
                  />
                )}
                <div className="card-body">
                  <h5 className="card-title">{book.title}</h5>
                  <p className="card-text">
                    <strong>Author:</strong> {book.author} <br />
                    <strong>Publisher:</strong> {book.publisher} <br />
                    <strong>Price:</strong> Rs.{book.price}/- <br />
                    <strong>Stock:</strong> {book.stock}
                  </p>
                  <Link
                    to={`/edit-book/${book.id}`}
                    className="btn custom-orange-btn me-2"
                  >
                    Edit
                  </Link>
                  <button
                    className="btn custom-dark-btn"
                    onClick={() => handleDelete(book.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Style (Move to a separate CSS file if not using scoped styles) */}
      <style jsx>{`
  



  .content {
    margin-left: 200px;
  }
  @media (max-width: 768px) {
    .vertical-nav {
      width: 100%;
    }
    .content {
      margin-left: 0;
    }
  }
.navbar {
background: #1a1a1a; /* Dark background color */
}

.vertical-nav {
background: #1a1a1a; /* Dark background color */
position: fixed;
top: 56px;
left: 0;
height: calc(100% - 56px);
overflow-y: auto;
padding-top: 30px;
z-index: 999;
}

.vertical-nav .nav-link {
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
padding: 10px 15px;
color: #ff6700; /* Dark orange font color */
transition: background-color 0.3s; /* Smooth hover effect */
}

.vertical-nav .nav-link:hover {
background-color: #2a2a2a; /* Slightly lighter background for hover effect */
}

.nav-icon {
font-size: 20px;
margin-right: 10px;
color: #ff6700; /* Dark orange for icons */
}

li {
border-bottom: 2px solid black;
}

li:hover {
background-color: #2a2a2a; /* Slightly lighter background for hover effect */
}


.btn {
width: 100%; /* Full-width button */
background-color: #ff6700; /* Dark orange background for button */
color: white;
border: none;
padding: 10px;
margin:10px;
font-size: 16px;
font-weight: bold;
border-radius: 5px;
}

.btn:hover {
background-color: #e65c00; /* Darker orange on hover */
cursor: pointer;
}

body {
position: relative;
margin: 0; /* Remove default margins */
padding: 0; /* Remove default padding */
}

body::before {
content: '';
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: url('https://wallpaperaccess.com/full/934072.jpg') no-repeat center center fixed;
background-size: cover; /* Ensure the image covers the entire body */
opacity: 0.4; /* Apply opacity only to the image */
z-index: -1; /* Place it behind all other content */
}

a {
text-decoration: none;
}

h1, h2, h3, h4, h5, h6 {
font-family: "Times New Roman", Times, serif; /* Classic font */
color: #1a1a1a; /* Match the theme color */
}




   .card {
      transition: all 0.3s ease-in-out;
      background-color: #fff;
      border-radius:24 px;
    }

    .card:hover {
      transform: translateY(-5px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .card-title {
      font-size: 1.2rem;
      font-weight: bold;
    }

    .card-text {
      color: #555;
      font-size: 0.95rem;
    }

    .custom-orange-btn {
      background-color: #ff6700; /* Orange Color */
      color: white;
      border: none;
      border-radius: 5px;
      padding: 8px 15px;
      transition: all 0.3s ease;
    }

    .custom-orange-btn:hover {
      background-color: #e65c00; /* Darker Orange */
      transform: translateY(-2px);
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }

    .custom-dark-btn {
    background-color: #a84300; /* Darker shade for hover effect */
      color: white;
      border: none;
      border-radius: 5px;
      padding: 8px 15px;
      transition: all 0.3s ease;
    }

    .custom-dark-btn:hover {
      background-color: #555; /* Lighter Dark */
      transform: translateY(-2px);
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }

    .img-thumbnail {
      border: 2px solid #ddd;
      transition: all 0.3s ease;
    }

    .img-thumbnail:hover {
      border-color: #ff6700; /* Highlight border on hover */
    }
`}</style>
</div>
  );
};

export default BooksList;
